import React from 'react';
import {useState} from "react";
import { Link, useParams } from 'react-router-dom';
import {LoginAPI} from '../../services';
import {JWTDecode} from '../../components/utils';
import md5 from 'md5';
import { LanguageLoader } from '../../assets/languages';
import { useSelector } from 'react-redux';

const Login = () =>
{
	const {lang} = useParams();
	let userLanguage = 'fa_IR';
	if(lang && lang.length)
	{
		userLanguage = lang;
		if(userLanguage === 'en_US')
		{
			document.documentElement.dir = 'ltr';
		}
	}
	const language = LanguageLoader(userLanguage);
	const loginSettings = useSelector((state) => state.loginSettings);
	const [username, SetUsername] = useState('');
	const [password, SetPassword] = useState('');
	const [showPassword, SetShowPassword] = useState(false);
	const registration = loginSettings.registration;

	const Authentication = async () =>
	{
		try
		{
			if(username.length && password.length)
			{
				const data = {
					"user_name": username,
					"password": md5(password)
				};
				/* SET LANGUAGE IN USER PREFERENCES */
				if(lang && lang.length)
				{
					data.language = lang;
				}
				const host = window.location.host;
				if(!host.includes('.') || host.split('.')[0] !== 'mobile')
				{
					data.login_type = "portal";
				}
				const APIResponse = await LoginAPI(data);
				if(APIResponse)
				{
					const token = APIResponse.token;
					const JTWDecoded = JWTDecode(token);
					if(JTWDecoded)
					{
						const language = (JTWDecoded.data.preferences && JTWDecoded.data.preferences.language) ? JTWDecoded.data.preferences.language : 'fa_IR';
						localStorage.setItem("language", language);
						localStorage.setItem("token", token);
						window.location.replace('/');
					}
				}
			}
		} catch(ex){}
	}

	return(
		<div className='mt-3' onKeyDown={(e) => {if(e.key === "Enter") Authentication();}}>
			<h2 className="text-secondaryFont text-center mt-14 absolute inset-x-0 -top-40" style={{color: loginSettings.color}}>{loginSettings.title ? loginSettings.title : language["AUTHENTICATION"]["LOGIN_TO_ACCOUNT"]}</h2>
			<input onChange={(e) => SetUsername(e.target.value)} placeholder={language["AUTHENTICATION"]["USERNAME"]} className="form-control mb-3 hover:border-[]" type="text" autoCapitalize='off'/>
			<div className="relative">
				<input onChange={(e) => SetPassword(e.target.value)} placeholder={language["AUTHENTICATION"]["PASSWORD"]} className="form-control mb-3" type={showPassword ? "text" : "password"} autoCapitalize='off' />
				<div className="absolute inset-y-0 left-1 pl-3 flex items-center text-sm leading-5 mb-3">
					<button type="button" onClick={() => SetShowPassword(!showPassword)}>
					{showPassword ? <i className='fa fa-eye-slash' /> : <i className='fa fa-eye' />}
					</button>
				</div>
			</div>
			<div className='flex justify-between mt-2 mb-2'>
				<div className='flex mb-5 gap-1'>
					<input type="checkbox"/>
					<label>{language["AUTHENTICATION"]["REMEMBER_ME"]}</label>
				</div>
				<Link to="/forgotpassword" className='text-xs'>{language["AUTHENTICATION"]["FORGOT_PASSWORD"]}</Link>
			</div>
			<button onClick={Authentication} type='button' className='btn-primary mb-1 mt-5 w-full bg-primary text-secondaryFont' style={{background: loginSettings.color, borderColor: loginSettings.color}}><span style={{color: loginSettings.background}}>{language["AUTHENTICATION"]["LOGIN"]}</span></button>
			{registration ? <Link to='/register'><button className='btn mb-1 w-full text-secondaryFont mt-2 secondary' style={{borderColor: loginSettings.color, color: loginSettings.color}}><span style={{color: loginSettings.background}}>{language["AUTHENTICATION"]["SIGN_UP"]}</span></button></Link> : null}
			<button className='btn secondary w-full mt-2 !border-warning' onClick={() => {localStorage.removeItem("utype"); window.location.replace('/utype');}}><span className='!text-warning' style={{color: loginSettings.background}}>{language["AUTHENTICATION"]["CHANGE_TENANT"]}</span></button>
		</div>
	);
}

export default Login;